import Router from 'next/router'

const pushRoute = async (props): Promise<boolean> => {
  // Ici nous attendons les props qui viennent de la fonction getRoutes qui est une fonction async. await est donc necessaire
  const resolved = await props
  if (!resolved) return false

  const { href, as, pathname, query, options } = resolved

  // On ne doit pas passer une icone au routeur car il n'arrive pas à la gérer sans planter (duplication error)
  return !!pathname ? Router.push({ pathname, query }) : Router.push(href, as, options)
}

export default pushRoute
